interface IMenuSquareIconProps {
  className?: string;
  strokeWidth?: number;
}

/**
 * -----------------------------------------------------------------------------
 * It renders a icon of list
 */
export function MenuSquareIcon({
  className,
  strokeWidth = 0.75,
}: Readonly<IMenuSquareIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M9.501 12H17M9.501 15.484H17M9.501 8.484H17M7.05 8.434a.05.05 0 0 0-.05.05c0 .029.023.05.051.05a.051.051 0 0 0 .051-.05.053.053 0 0 0-.052-.05M7.05 11.949A.05.05 0 0 0 7 12c0 .028.023.051.051.051A.051.051 0 0 0 7.102 12a.052.052 0 0 0-.052-.051M7.05 15.434a.05.05 0 0 0-.05.05c0 .029.023.05.051.05a.051.051 0 0 0 .051-.05.053.053 0 0 0-.052-.05"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <path
        clipRule="evenodd"
        d="M21 7v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
